/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IAriSearchResultsViewProps } from './ari-search-results';

export default (props: IAriSearchResultsViewProps) => {
    const { modelTable, pagination } = props;
    return (
        <div className='row'>
            {modelTable}
            {pagination}
            {/* {notFindingMessage} */}
        </div>
    );
};
